// BlogList.js

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // If you're using React Router
import "../styles/BlogList.css";
import { getBlogImage } from "../utils/blogImages";
import api, { API_ENDPOINTS } from "../config/api";
import BackToTop from "./BackToTop";
import SEO from "./SEO";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const response = await api.get(API_ENDPOINTS.BLOGS.LIST);
        setBlogs(response.data);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Function to get a random reading time for demo purposes
  const getReadingTime = () => {
    return `${Math.floor(Math.random() * 10) + 3} min read`;
  };

  if (loading) {
    return (
      <div className="loading-indicator">
        <p>Loading blogs...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-empty">
        <p>{error}</p>
      </div>
    );
  }

  if (blogs.length === 0) {
    return (
      <div className="blog-empty">
        <h2>No blogs found</h2>
        <p>Check back later for new content.</p>
      </div>
    );
  }

  return (
    <div className="blogs-container">
      <SEO
        title="Study Abroad Blog - Expert Tips & Guidance | Grad4Grad"
        description="Read expert articles on study abroad, university admissions, visa guides, student life, and more. Get comprehensive guidance for international students from our educational experts."
        keywords="study abroad blog, university admissions tips, international student blog, visa guide blog, student life abroad, educational guidance, study abroad advice"
        image="https://grad4grad.com/logo512.png"
        url="https://grad4grad.com/blogs"
        type="website"
      />
      <div className="blogs-header">
        <h1>Grad4Grad Blog</h1>
        <p>
          Discover insights, tips, and guidance on studying abroad, university
          admissions, and making the most of your educational journey.
        </p>
      </div>

      <div className="blog-grid">
        {blogs.map((blog) => (
          <article key={blog.slug} className="blog-card">
            <Link to={`/blogs/${blog.slug}`} className="blog-link">
              <div className="blog-image">
                <img
                  src={getBlogImage(blog.slug)}
                  alt={blog.title}
                  onError={(e) => {
                    e.target.src = getBlogImage("default"); // Fallback to default image if image fails to load
                  }}
                />
              </div>
              <div className="blog-content">
                <span className="blog-category">{blog.category}</span>
                <h2 className="blog-title">{blog.title}</h2>
                <div className="blog-meta">
                  <span>{blog.date}</span>
                  <span>•</span>
                  <span>{getReadingTime()}</span>
                </div>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <span className="read-more">Read Article</span>
              </div>
            </Link>
          </article>
        ))}
      </div>
      <BackToTop />
    </div>
  );
};

export default BlogList;
